// extracted by mini-css-extract-plugin
export default {"date":"YYmZC","eventList":"n-hWH","dateText":"_8iaH6","eventDetails":"xwJXN","dateWithChevron":"DBUMS","dateChevron":"_5agVN","close":"_6qZfh"};